import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslationService } from 'libs/core/src/lib/service/translation.service';
import { OrderStateService } from 'libs/core/src/lib/state/order.state.service';
import { CartModel } from '../model/cart.model';
import { CartService } from '../service/cart.service';
import { CinemaViewModel, OrderViewModel } from '@lib/core';
import { CinemaDataProvider } from 'libs/core/src/lib/data-provider/cinema.data-provider';
import { CartScreeningModel } from '../model/cart-screening.model';

@Component({
  selector: 'app-cart-movie-summary-component',
  templateUrl: './movie-summary.component.html'
})
export class MovieSummaryComponent implements OnInit, OnDestroy {
  @Input()
  public cinema: CinemaViewModel = null;
  public showMore: { [key: string]: boolean } = {};

  public cart: CartModel = null;

  private cartSubscription: Subscription = Subscription.EMPTY;
  private orderStateSubscription: Subscription = Subscription.EMPTY;

  constructor(
    private cartService: CartService,
    private orderStateService: OrderStateService,
    public translationService: TranslationService,
    private cinemaDataProvider: CinemaDataProvider
  ) {}

  public ngOnInit(): void {
    const cartState: CartModel = this.cartService.getCart();
    this.onCartStateChanged(cartState);
    this.cartSubscription = this.cartService.cartState.subscribe((cart) => this.onCartStateChanged(cart));
    this.orderStateSubscription = this.orderStateService.state$.subscribe((state) => this.onOrderStateChanged(state));
  }

  public ngOnDestroy(): void {
    if (this.cartSubscription !== Subscription.EMPTY) {
      this.cartSubscription.unsubscribe();
      this.cartSubscription = Subscription.EMPTY;
    }

    if (this.orderStateSubscription !== Subscription.EMPTY) {
      this.orderStateSubscription.unsubscribe();
      this.orderStateSubscription = Subscription.EMPTY;
    }
  }

  private onCartStateChanged(value: CartModel): void {
    this.cart = value;

    if (!value) {
      return;
    }

    const showMore: { [key: string]: boolean } = {};

    value.screeningItems.forEach((x) => {
      showMore[x.screeningId] = this.showMore[x.screeningId] && this.showMore[x.screeningId] === true;
    });

    this.showMore = showMore;
  }

  getDescription(screeningItem: CartScreeningModel) {
    const description = screeningItem?.items[0]?.movieDescription;
    if (description) {
      const translationKey = description.toTranslationKey('screen.movie');
      if (this.translationService.isTranslationExists(translationKey)) {
        return `- ${this.translationService.instant(translationKey)}`;
      }
    }

    return '';
  }

  private onOrderStateChanged(order: OrderViewModel): void {
    if (this.cinema?.id !== order.cinemaId) {
      this.cinemaDataProvider.getCinemaById(order.cinemaId).subscribe((cinema) => (this.cinema = cinema));
    }
  }
}
